<template>
  <div class="chatBox">
    <div class="chat_dom" ref="chat_dom">
      <!-- 聊天对话  -->
      <template v-for="(item, index) in chatData">
        <!-- 时间分割线（独立于气泡之外，不受 float 影响） -->
        <div
          v-if="shouldShowTime(index)"
          :key="'time-' + index"
          class="time-divider"
        >{{ item.createTime }}</div>
        <div :key="'msg-' + index" class="chat_list">
          <!-- 机器人 -->
          <div v-if="item.role === 'assistant'|| item.role === 'customer'" class="left_dom">
            <div class="left_dom_text">
              <!-- 语音消息 -->
              <div v-if="item.msgType === 2" class="voice-message" @click="playVoice(item, index)">
                <img
                  :src="require('@/image/yuyin.png')"
                  class="voice-icon"
                  :class="{ playing: playingVoiceId === (item.id || index) }"
                />
                <span class="voice-text">{{ getVoiceText(item, index) }}</span>
                <audio
                  :ref="'audio_' + (item.id || index)"
                  :src="item.content"
                  @ended="onVoiceEnded(item.id || index)"
                  style="display:none;"
                ></audio>
              </div>
              <!-- 链接消息 -->
              <p
                class="linkText"
                style="white-space: pre-wrap;"
                @click="handleLink(item)"
                v-else-if="item.msgType==3"
              >{{item.content.data}}</p>
              <!-- 文本消息 -->
              <template v-else>
                <p style="white-space: pre-wrap;">{{ item.content }}</p>
                <div class="tts-action">
                  <button
                    class="tts-btn"
                    :class="{ 'tts-btn--playing': ttsPlayingId === (item.id || index) }"
                    @click="toggleTTS(item, index)"
                  >
                    <!-- 播放中：停止图标 -->
                    <svg v-if="ttsPlayingId === (item.id || index)" width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                      <rect x="4" y="4" width="16" height="16" rx="2"/>
                    </svg>
                    <!-- 未播放：喇叭图标 -->
                    <svg v-else width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
                      <path d="M19.07 4.93a10 10 0 0 1 0 14.14"/>
                      <path d="M15.54 8.46a5 5 0 0 1 0 7.07"/>
                    </svg>
                  </button>
                </div>
              </template>
            </div>
          </div>
          <!-- 用户右 -->
          <div v-if="item.role === 'user'" class="right_dom">
            <!-- 语音消息 -->
            <div
              v-if="item.msgType === 2"
              class="voice-message voice-message--right"
              @click="playVoice(item, index)"
            >
              <span class="voice-text">{{ getVoiceText(item, index) }}</span>
              <img
                :src="require('@/image/yuyin.png')"
                class="voice-icon"
                :class="{ playing: playingVoiceId === (item.id || index) }"
              />
              <audio
                :ref="'audio_' + (item.id || index)"
                :src="item.content"
                @ended="onVoiceEnded(item.id || index)"
                style="display:none;"
              ></audio>
            </div>
            <!-- 文本消息 -->
            <div class="right_dom_text" v-else>{{ item.content }}</div>
          </div>
          <div class="clearboth"></div>
        </div>
      </template>
      <!-- 机器人输入中动画 -->
      <div v-if="isTyping" class="typing-wrapper">
        <TypingIndicator />
      </div>
    </div>
    <!-- 输入框 -->
    <div class="input_dom">
      <!-- 语音录制全屏交互 -->
      <div v-if="recording" class="recording-fullscreen">
        <div class="recording-actions">
          <!-- 左侧：取消 -->
          <div class="action-item action-cancel" :class="{ active: recordingAction === 'cancel' }">
            <div class="action-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
              </svg>
            </div>
            <p class="action-label">取消</p>
          </div>
          <!-- 中间：录音动画 -->
          <div class="action-item action-center" :class="{ active: recordingAction === 'send' }">
            <div class="recording-icon">
              <span class="rec-dot"></span>
              <span class="rec-dot"></span>
              <span class="rec-dot"></span>
            </div>
            <p class="action-label">{{ recordingDuration }}"</p>
            <p class="action-hint">松开发送语音</p>
          </div>
          <!-- 右侧：转文字 -->
          <div class="action-item action-text" :class="{ active: recordingAction === 'text' }">
            <div class="action-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
              </svg>
            </div>
            <p class="action-label">转文字</p>
          </div>
        </div>
        <p class="recording-guide">← 左滑取消　　右滑转文字 →</p>
      </div>
      <div class="input_row">
        <!-- 模式切换按钮 -->
        <div class="mic-btn" @click="toggleInputMode">
          <img
            :src="inputMode === 'text' ? require('../../image/yuyin.png') : require('../../image/jianpan.png')"
            class="mode-icon"
          />
        </div>
        <!-- 文本输入模式 -->
        <template v-if="inputMode === 'text'">
          <input
            class="input"
            placeholder="请输入您的问题..."
            v-model="textarea"
            @keydown.enter="handleEnter"
          />
          <img src="../../image/send.png" alt class="sendBtn" v-if="textarea === ''" />
          <img src="../../image/send_active.png" alt class="sendBtn" @click="sendBtn" v-else />
        </template>
        <!-- 语音输入模式 -->
        <template v-else>
          <div
            class="voice-input-btn"
            :class="{ 'voice-input-btn--active': recording }"
            @touchstart.prevent="startRecording"
            @touchend.prevent="stopRecording"
            @touchmove.prevent="handleTouchMove"
            @mousedown.prevent="startRecording"
            @mouseup.prevent="stopRecording"
            @mousemove.prevent="handleTouchMove"
            @mouseleave.prevent="cancelRecording"
          >{{ recording ? '录音中...' : '按住 说话' }}</div>
        </template>
      </div>
    </div>
    <van-overlay :show="show">
      <div class="wrapper" @click="close">
        <div class="block" @click.stop>
          <h2>{{ item.title }}</h2>
          <br />
          <p>{{ item.content }}</p>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Toast } from "vant";
import TypingIndicator from "../typingIndicator/index.vue";
import { writeFiles, transcribeAudio } from "@/services/chatAI/index.js";
import { getSocket } from "@/utils/socket";
export default {
  name: "ChatBox",
  components: {
    TypingIndicator
  },
  props: {
    chatData: {
      type: Array
    },
    isTyping: {
      type: Boolean,
      default: false
    },
    robotInfo: {
      type: Object
    }
  },
  beforeDestroy() {
    // 清除录音计时器
    if (this.recordingTimer) {
      clearInterval(this.recordingTimer);
      this.recordingTimer = null;
    }
    // 停止录音
    if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
      this.mediaRecorder.stop();
    }
  },
  data() {
    return {
      isMore: false,
      show: false,
      item: {},
      textarea: "",
      playingVoiceId: null,
      // 输入模式：'text' 文本输入 | 'voice' 语音输入
      inputMode: "text",
      // 录音相关
      recording: false,
      recordingAction: "send", // send=发送语音 | cancel=取消 | text=转文字
      recordingDuration: 0, // 当前录音时长（秒）
      recordingTimer: null, // 录音计时器
      mediaRecorder: null,
      audioChunks: [],
      recordStartTime: null,
      recordStartX: null,
      recordStartY: null,
      microphoneGranted: false, // 麦克风权限是否已授予
      // TTS 流式播报
      ttsPlayingId: null,
      ttsAudioCtx: null,
      ttsCurrentRequestId: null,
      _ttsNextTime: 0,        // AudioContext 时间轴游标
      _ttsPendingBuffer: new Uint8Array(0), // 待调度的 PCM 缓冲区
      _ttsSampleRate: 16000,
      _ttsNumChannels: 1,
      // 流式 TTS 队列
      ttsQueue: [],           // 待播报的文本片段队列
      ttsQueueProcessing: false, // 是否正在处理队列
      ttsQueueMsgId: null     // 当前队列对应的消息ID
    };
  },
  methods: {
    handleFair() {
      this.$router.push({
        path: "/fairInfo/" + this.robotInfo?.robot_code
      });
    },
    more() {
      this.isMore = !this.isMore;
    },
    close() {
      this.show = false;
    },
    /* 发送 */
    sendBtn() {
      // console.log("textarea", this.textarea);
      if (this.textarea === "") {
        Toast("请输入内容~");
      } else {
        this.$emit("sendBtn", this.textarea);
      }
    },
    /* 键盘回车事件处理 */
    handleEnter(event) {
      if (event.metaKey || event.altKey || event.ctrlKey || event.shiftKey) {
        console.log("换行");
      } else if (event.keyCode == 13) {
        this.sendBtn();
        event.preventDefault();
      }
    },

    /* 播放 / 暂停语音消息 */
    playVoice(item, index) {
      const key = item.id || index;
      const refKey = "audio_" + key;
      const audioRef = this.$refs[refKey];
      const audio = Array.isArray(audioRef) ? audioRef[0] : audioRef;
      if (!audio) return;

      if (this.playingVoiceId === key) {
        audio.pause();
        this.playingVoiceId = null;
        return;
      }

      // 停止其他正在播放的语音
      if (this.playingVoiceId !== null) {
        const prevRef = this.$refs["audio_" + this.playingVoiceId];
        const prevAudio = Array.isArray(prevRef) ? prevRef[0] : prevRef;
        if (prevAudio) prevAudio.pause();
      }

      this.playingVoiceId = key;
      audio.play().catch(err => {
        console.error("播放语音失败", err);
        Toast("播放语音失败");
        this.playingVoiceId = null;
      });
    },

    /* 语音播放结束 */
    onVoiceEnded(key) {
      if (this.playingVoiceId === key) {
        this.playingVoiceId = null;
      }
    },

    /* 语音气泡显示文本 */
    getVoiceText(item, index) {
      const key = item.id || index;
      if (this.playingVoiceId === key) return "播放中...";
      if (item.voiceTime) return `语音 ${item.voiceTime}"`;
      return "点击播放";
    },

    /* 判断是否显示时间分割线：与上一条消息间隔 >= 5 分钟则显示，兼容 "2026-03-26 21:01:38" 格式 */
    shouldShowTime(index) {
      const cur = this.chatData[index];
      if (!cur || !cur.createTime) return false;
      if (index === 0) return true;
      const prev = this.chatData[index - 1];
      if (!prev || !prev.createTime) return false;
      const toDate = t => new Date(String(t).replace(" ", "T"));
      const diff = toDate(cur.createTime) - toDate(prev.createTime);
      return diff >= 5 * 60 * 1000;
    },

    /* 跳转链接，仅小程序h5环境才生效 */
    handleLink(item) {
      if (item.msgType !== 3) return;
      try {
        wx.miniProgram.navigateTo({
          url: item.content.link //pages/information/information
        });
      } catch (error) {
        console.log("error", error);
        Toast("该链接已失效或仅支持在微信中打开");
      }
    },

    /* ========== 输入模式切换 ========== */
    toggleInputMode() {
      this.inputMode = this.inputMode === "text" ? "voice" : "text";
    },

    /* ========== 长按录音 ========== */
    async startRecording(e) {
      // 获取起始坐标（兼容 touch 和 mouse）
      this.recordStartX = e.touches ? e.touches[0].clientX : e.clientX;
      this.recordStartY = e.touches ? e.touches[0].clientY : e.clientY;
      this.recordingAction = "send";

      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        Toast("当前浏览器不支持录音");
        return;
      }
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true
        });
        
        // 如果是首次授权，仅获取权限但不开始录音
        if (!this.microphoneGranted) {
          this.microphoneGranted = true;
          // 立即释放媒体流
          stream.getTracks().forEach(t => t.stop());
          Toast("麦克风权限已开启，请再次按住说话");
          return;
        }
        this.audioChunks = [];
        this.recordStartTime = Date.now();

        const mimeType = MediaRecorder.isTypeSupported("audio/mpeg")
          ? "audio/mpeg"
          : MediaRecorder.isTypeSupported("audio/webm;codecs=opus")
          ? "audio/webm;codecs=opus"
          : MediaRecorder.isTypeSupported("audio/webm")
          ? "audio/webm"
          : "audio/ogg";

        this.mediaRecorder = new MediaRecorder(stream, { mimeType });
        this.mediaRecorder.ondataavailable = ev => {
          if (ev.data && ev.data.size > 0) this.audioChunks.push(ev.data);
        };
        this.mediaRecorder.onstop = () => {
          stream.getTracks().forEach(t => t.stop());
        };
        this.mediaRecorder.start();
        this.recording = true;
        // 启动计时器，每100ms更新一次录音时长
        this.recordingDuration = 0;
        this.recordingTimer = setInterval(() => {
          if (this.recording) {
            const elapsed = Math.floor((Date.now() - this.recordStartTime) / 1000);
            this.recordingDuration = elapsed;
            
            // 达到60秒自动停止录音
            if (elapsed >= 60) {
              Toast("录音时长已达上限");
              this.stopRecording();
            }
          }
        }, 100);
      } catch (err) {
        console.error("麦克风权限获取失败", err);
        Toast("麦克风权限获取失败，请检查浏览器设置");
        // 权限失败时，确保释放按钮
        this.recording = false;
        this.recordingAction = "send";
        this.recordingDuration = 0;
      }
    },

    handleTouchMove(e) {
      if (!this.recording) return;
      const currentX = e.touches ? e.touches[0].clientX : (e.clientX || this.recordStartX);
      const currentY = e.touches ? e.touches[0].clientY : (e.clientY || this.recordStartY);
      const diffX = currentX - this.recordStartX;
      const diffY = this.recordStartY - currentY;

      // 左滑：取消（距离 > 80px）
      if (diffX < -80) {
        this.recordingAction = "cancel";
      }
      // 右滑：转文字（距离 > 80px）
      else if (diffX > 80) {
        this.recordingAction = "text";
      }
      // 居中：发送语音
      else {
        this.recordingAction = "send";
      }
    },

    cancelRecording() {
      if (!this.recording) return;
      this.recordingAction = "cancel";
      this.stopRecording();
    },

    async stopRecording() {
      if (!this.recording || !this.mediaRecorder) return;
      this.recording = false;
      
      // 停止计时器
      if (this.recordingTimer) {
        clearInterval(this.recordingTimer);
        this.recordingTimer = null;
      }

      const voiceTime = Math.round((Date.now() - this.recordStartTime) / 1000);
      const action = this.recordingAction;

      // 等待 onstop 触发后再处理数据
      await new Promise(resolve => {
        this.mediaRecorder.addEventListener("stop", resolve, { once: true });
        this.mediaRecorder.stop();
      });

      // 取消或录音太短
      if (action === "cancel" || voiceTime < 1) {
        if (voiceTime < 1) Toast("录音时间太短");
        this.audioChunks = [];
        this.recordingAction = "send";
        this.recordingDuration = 0;
        return;
      }

      const mimeType = this.mediaRecorder.mimeType || "audio/webm";
      const audioBlob = new Blob(this.audioChunks, { type: mimeType });
      this.audioChunks = [];

      // 转文字
      if (action === "text") {
        Toast.loading({ message: "识别中...", forbidClick: true, duration: 0 });
        try {
          const result = await transcribeAudio(audioBlob, "auto");
          Toast.clear();
          if (result.code === 200 && result.data && result.data.text) {
            // 将识别的文字填充到输入框
            this.textarea = result.data.text;
            this.inputMode = "text"; // 切换回文本模式
            Toast.success("识别成功");
          } else {
            Toast("语音识别失败");
          }
        } catch (err) {
          Toast.clear();
          console.error("语音识别失败", err);
          Toast("语音识别失败");
        }
        this.recordingAction = "send";
        this.recordingDuration = 0;
        return;
      }

      // 发送语音（默认）
      Toast.loading({ message: "上传中...", forbidClick: true, duration: 0 });
      try {
        const result = await writeFiles(audioBlob);
        Toast.clear();
        if (result.code === 200 && result.data) {
          this.$emit("sendVoice", { url: result.data, voiceTime });
        } else {
          Toast("上传录音失败");
        }
      } catch (err) {
        Toast.clear();
        console.error("上传录音失败", err);
        Toast("上传录音失败");
      }
      this.recordingAction = "send";
      this.recordingDuration = 0;
    },

    /* ========== TTS 流式播报 ========== */
    toggleTTS(item, index) {
      const key = item.id || index;
      if (this.ttsPlayingId === key) {
        this.stopTTS();
        return;
      }
      this.stopTTS();
      const text = typeof item.content === "string" ? item.content.trim() : "";
      if (!text) return;
      this.startTTSSocketStream(text, key);
    },

    stopTTS() {
      // 通知后端停止（如果正在合成）
      if (this.ttsCurrentRequestId) {
        const socket = getSocket();
        socket.emit('tts:stop', { requestId: this.ttsCurrentRequestId });
        this.ttsCurrentRequestId = null;
      }
      if (this.ttsAudioCtx) {
        this.ttsAudioCtx.close().catch(() => {});
        this.ttsAudioCtx = null;
      }
      this.ttsPlayingId = null;
      this._ttsNextTime = 0;
      this._ttsPendingBuffer = new Uint8Array(0);
    },

    /* 内部：把 PCM Uint8Array 调度到 AudioContext */
    _schedulePCM(pcmBytes, sampleRate, numChannels) {
      const audioCtx = this.ttsAudioCtx;
      if (!audioCtx) return null;
      const totalSamples = Math.floor(pcmBytes.length / (2 * numChannels));
      if (totalSamples < 1) return null;
      const audioBuf = audioCtx.createBuffer(numChannels, totalSamples, sampleRate);
      const view = new DataView(pcmBytes.buffer, pcmBytes.byteOffset, pcmBytes.byteLength);
      for (let ch = 0; ch < numChannels; ch++) {
        const channelData = audioBuf.getChannelData(ch);
        for (let i = 0; i < totalSamples; i++) {
          channelData[i] = view.getInt16((i * numChannels + ch) * 2, true) / 32768;
        }
      }
      const source = audioCtx.createBufferSource();
      source.buffer = audioBuf;
      source.connect(audioCtx.destination);
      const startAt = Math.max(this._ttsNextTime, audioCtx.currentTime + 0.01);
      source.start(startAt);
      this._ttsNextTime = startAt + audioBuf.duration;
      return source;
    },

    /* ========== Socket.io TTS 流式播报 ========== */
    startTTSSocketStream(text, key) {
      const socket = getSocket();
      
      // 检查连接状态
      if (!socket || !socket.connected) {
        console.error('[TTS] Socket 未连接');
        Toast('连接未建立，请稍后重试');
        return;
      }
      
      const requestId = `tts_${key}_${Date.now()}`;
      this.ttsCurrentRequestId = requestId;
      this.ttsPlayingId = key;

      console.log(`[TTS] 开始请求，requestId: ${requestId}, text: "${text.substring(0, 30)}..."`);

      // 初始化 AudioContext
      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      this.ttsAudioCtx = new AudioCtx({ sampleRate: this._ttsSampleRate });
      this._ttsNextTime = this.ttsAudioCtx.currentTime + 0.05;
      this._ttsPendingBuffer = new Uint8Array(0);

      let lastSource = null;
      let MIN_BYTES = 240 * 2 * this._ttsNumChannels; // 最小调度单元 ~10ms（会在收到 start 事件后更新）

      // 监听开始事件
      socket.once('tts:start', (data) => {
        if (data.requestId === requestId) {
          console.log('[TTS] 开始合成:', data.message);
          
          // 动态设置采样率和声道数
          if (data.sampleRate) {
            this._ttsSampleRate = data.sampleRate;
            console.log('[TTS] 设置采样率:', data.sampleRate);
          }
          if (data.numChannels) {
            this._ttsNumChannels = data.numChannels;
            MIN_BYTES = 240 * 2 * this._ttsNumChannels; // 更新 MIN_BYTES
            console.log('[TTS] 设置声道数:', data.numChannels, '最小字节数:', MIN_BYTES);
          }
          
          // 重新初始化 AudioContext（如果采样率变化）
          if (this.ttsAudioCtx && this.ttsAudioCtx.sampleRate !== this._ttsSampleRate) {
            this.ttsAudioCtx.close();
            const AudioCtx = window.AudioContext || window.webkitAudioContext;
            this.ttsAudioCtx = new AudioCtx({ sampleRate: this._ttsSampleRate });
            this._ttsNextTime = this.ttsAudioCtx.currentTime + 0.05;
            console.log('[TTS] 重新初始化 AudioContext，采样率:', this._ttsSampleRate);
          }
        }
      });

      // 监听音频数据
      const onData = (data) => {
        if (data.requestId !== requestId) return;
        if (this.ttsPlayingId !== key) return;

        // Socket.io 会将 Buffer 转为 ArrayBuffer，需要正确转换
        let pcmChunk;
        if (data.data instanceof ArrayBuffer) {
          pcmChunk = new Uint8Array(data.data);
        } else if (data.data instanceof Uint8Array) {
          pcmChunk = data.data;
        } else if (data.data.buffer) {
          // 如果是 Buffer 对象
          pcmChunk = new Uint8Array(data.data.buffer || data.data);
        } else {
          console.error('[TTS] 未知的数据格式:', typeof data.data, data.data);
          return;
        }

        // console.log(`[TTS] 收到数据块 ${data.chunkIndex}，大小: ${pcmChunk.length} bytes`);

        const merged = new Uint8Array(this._ttsPendingBuffer.length + pcmChunk.length);
        merged.set(this._ttsPendingBuffer);
        merged.set(pcmChunk, this._ttsPendingBuffer.length);
        this._ttsPendingBuffer = merged;

        // 累积到一定大小后调度播放
        while (this._ttsPendingBuffer.length >= MIN_BYTES) {
          const takeBytes = Math.min(
            this._ttsPendingBuffer.length - (this._ttsPendingBuffer.length % (2 * this._ttsNumChannels)),
            4800 * 2 * this._ttsNumChannels
          );
          const src = this._schedulePCM(
            this._ttsPendingBuffer.slice(0, takeBytes),
            this._ttsSampleRate,
            this._ttsNumChannels
          );
          if (src) lastSource = src;
          this._ttsPendingBuffer = this._ttsPendingBuffer.slice(takeBytes);
        }
      };
      socket.on('tts:data', onData);

      // 监听最后一块标记
      socket.once('tts:last', (data) => {
        if (data.requestId === requestId) {
          console.log('[TTS] 收到最后一块标记');
        }
      });

      // 监听完成事件
      socket.once('tts:end', (data) => {
        if (data.requestId !== requestId) return;
        console.log('[TTS] 合成完成:', data);

        // 移除数据监听器
        socket.off('tts:data', onData);

        // 调度剩余缓冲
        if (this._ttsPendingBuffer.length >= 2 * this._ttsNumChannels) {
          const src = this._schedulePCM(
            this._ttsPendingBuffer,
            this._ttsSampleRate,
            this._ttsNumChannels
          );
          if (src) lastSource = src;
        }

        // 最后一个 source 播放完后重置状态
        if (lastSource) {
          lastSource.onended = () => {
            if (this.ttsPlayingId === key) {
              this.ttsPlayingId = null;
            }
            this.ttsCurrentRequestId = null;
          };
        } else {
          // 没有音频数据时立即重置
          if (this.ttsPlayingId === key) {
            this.ttsPlayingId = null;
          }
          this.ttsCurrentRequestId = null;
        }

        this._ttsPendingBuffer = new Uint8Array(0);
      });

      // 监听错误事件
      socket.once('tts:error', (data) => {
        if (data.requestId !== requestId) return;
        console.error('[TTS] 错误:', data.message);
        Toast('语音播报失败');
        socket.off('tts:data', onData);
        this.ttsPlayingId = null;
        this.ttsCurrentRequestId = null;
      });

      // 发送合成请求
      console.log('[TTS] 发送合成请求...');
      socket.emit('tts:synthesize', {
        text,
        timbre_id: 'timbre_c08d3dcdf3144a17bb729aaab6096828',
        speed: 1.0,
        requestId,
      });
      console.log('[TTS] 请求已发送，等待响应...');
    },

    /**
     * 供父组件调用：完整文本一次性 TTS（非流式文字回复 / 手动点击）
     */
    autoPlayTTS(item, index) {
      if (!item || item.msgType === 2) return;
      const text = typeof item.content === "string" ? item.content.trim() : "";
      if (!text) return;
      const key = item.id || index;
      if (this.ttsPlayingId === key) return;
      this.stopTTS();
      this.startTTSSocketStream(text, key);
    },

    /**
     * 供父组件调用：流式播报 - 将文本片段加入队列并按顺序播报
     * @param {string} textChunk - 文本片段
     * @param {number} msgIndex - 消息索引
     */
    queueTTSText(textChunk, msgIndex) {
      if (!textChunk || typeof textChunk !== 'string') return;
      const trimmed = textChunk.trim();
      if (!trimmed) return;

      const key = msgIndex;
      
      // 如果是新消息，清空队列
      if (this.ttsQueueMsgId !== key) {
        this.ttsQueue = [];
        this.ttsQueueMsgId = key;
        this.ttsQueueProcessing = false;
      }

      // 加入队列
      this.ttsQueue.push(trimmed);
      
      // 启动队列处理
      this._processTTSQueue(key);
    },

    /**
     * 内部方法：处理 TTS 队列
     */
    async _processTTSQueue(msgKey) {
      // 如果已在处理或队列为空，直接返回
      if (this.ttsQueueProcessing || this.ttsQueue.length === 0) return;
      
      this.ttsQueueProcessing = true;

      while (this.ttsQueue.length > 0) {
        const textChunk = this.ttsQueue.shift();
        
        // 检查是否还是同一条消息
        if (this.ttsQueueMsgId !== msgKey) {
          this.ttsQueueProcessing = false;
          this.ttsPlayingId = null;
          return;
        }

        // 等待当前播报完成
        await this._playTTSChunk(textChunk, msgKey);
      }

      // 队列播放完成，重置状态
      this.ttsQueueProcessing = false;
      if (this.ttsPlayingId === msgKey) {
        this.ttsPlayingId = null;
      }
    },

    /**
     * 内部方法：播报单个文本片段并等待完成
     */
    _playTTSChunk(text, key) {
      return new Promise((resolve) => {
        const socket = getSocket();
        
        // 检查连接状态
        if (!socket || !socket.connected) {
          console.error('[TTS] Socket 未连接');
          resolve();
          return;
        }

        const requestId = `tts_queue_${key}_${Date.now()}`;
        this.ttsCurrentRequestId = requestId;
        this.ttsPlayingId = key;

        // 初始化 AudioContext
        if (!this.ttsAudioCtx || this.ttsAudioCtx.state === 'closed') {
          const AudioCtx = window.AudioContext || window.webkitAudioContext;
          this.ttsAudioCtx = new AudioCtx({ sampleRate: this._ttsSampleRate });
          this._ttsNextTime = this.ttsAudioCtx.currentTime + 0.05;
          this._ttsPendingBuffer = new Uint8Array(0);
        }

        let lastSource = null;
        let MIN_BYTES = 240 * 2 * this._ttsNumChannels;

        // 监听开始事件
        socket.once('tts:start', (data) => {
          if (data.requestId === requestId) {
            if (data.sampleRate) this._ttsSampleRate = data.sampleRate;
            if (data.numChannels) {
              this._ttsNumChannels = data.numChannels;
              MIN_BYTES = 240 * 2 * this._ttsNumChannels;
            }
          }
        });

        // 监听音频数据
        const onData = (data) => {
          if (data.requestId !== requestId) return;

          let pcmChunk;
          if (data.data instanceof ArrayBuffer) {
            pcmChunk = new Uint8Array(data.data);
          } else if (data.data instanceof Uint8Array) {
            pcmChunk = data.data;
          } else if (data.data.buffer) {
            pcmChunk = new Uint8Array(data.data.buffer || data.data);
          } else {
            return;
          }

          const merged = new Uint8Array(this._ttsPendingBuffer.length + pcmChunk.length);
          merged.set(this._ttsPendingBuffer);
          merged.set(pcmChunk, this._ttsPendingBuffer.length);
          this._ttsPendingBuffer = merged;

          while (this._ttsPendingBuffer.length >= MIN_BYTES) {
            const takeBytes = Math.min(
              this._ttsPendingBuffer.length - (this._ttsPendingBuffer.length % (2 * this._ttsNumChannels)),
              4800 * 2 * this._ttsNumChannels
            );
            const src = this._schedulePCM(
              this._ttsPendingBuffer.slice(0, takeBytes),
              this._ttsSampleRate,
              this._ttsNumChannels
            );
            if (src) lastSource = src;
            this._ttsPendingBuffer = this._ttsPendingBuffer.slice(takeBytes);
          }
        };
        socket.on('tts:data', onData);

        // 监听完成事件
        socket.once('tts:end', (data) => {
          if (data.requestId !== requestId) return;

          socket.off('tts:data', onData);

          // 调度剩余缓冲
          if (this._ttsPendingBuffer.length >= 2 * this._ttsNumChannels) {
            const src = this._schedulePCM(
              this._ttsPendingBuffer,
              this._ttsSampleRate,
              this._ttsNumChannels
            );
            if (src) lastSource = src;
          }

          // 等待播放完成
          if (lastSource) {
            lastSource.onended = () => {
              this.ttsCurrentRequestId = null;
              this._ttsPendingBuffer = new Uint8Array(0);
              resolve();
            };
          } else {
            this.ttsCurrentRequestId = null;
            this._ttsPendingBuffer = new Uint8Array(0);
            resolve();
          }
        });

        // 监听错误事件
        socket.once('tts:error', (data) => {
          if (data.requestId !== requestId) return;
          socket.off('tts:data', onData);
          this.ttsCurrentRequestId = null;
          resolve();
        });

        // 发送合成请求
        socket.emit('tts:synthesize', {
          text,
          timbre_id: 'timbre_c08d3dcdf3144a17bb729aaab6096828',
          speed: 1.0,
          requestId,
        });
      });
    }
  }
};
</script>

<style scoped lang="less">
.chatBox {
  width: 100%;
  background: #ffffff;
  position: relative;
  font-size: 14px;
  letter-spacing: 0.8px;
  height: 100%;
}

img {
  width: 30px;
  height: 30px;
  display: block;
}
/* 聊天窗口内容部分 */
.chat_dom {
  height: calc(100vh - 180px);
  // height: 88%;
  overflow-y: scroll;
  overflow-x: hidden;
  // border: 1px solid red;
  // border: 1px solid rgb(0, 0, 0);
}
// .chat_list {
// border: 1px solid rgb(0, 21, 255);
// }
.clearboth {
  clear: both;
}

.right_dom,
.left_dom {
  display: flex;
  margin: 10px;
  max-width: 90%;
  position: relative;
  > div {
    margin: 0 10px;
  }
  .icon {
    // width: 100px;
    position: absolute;
    right: 20px;
    bottom: -30px;
    display: flex;
    img {
      width: 16px;
      height: 16px;
      margin: 0 5px;
      display: block;
    }
    img:hover {
      cursor: pointer;
    }
  }
}

.right_dom {
  float: right;
}

.left_dom {
  float: left;
  // margin-bottom: 50px;
}

/* 聊天气泡 */
.left_dom_text,
.right_dom_text {
  padding: 14px 20px;
  // flex-wrap: wrap;
  line-height: 20px;
  border-radius: 20px;
  width: 100%;
  max-width: 70%;
}

.right_dom_text {
  background: #1d6aff;
  color: #ffffff;
}

.left_dom_text {
  background: #edf3ff;
  color: #161616;
  /* 知识库 */
  // .docs-box {
  //   width: 100%;
  //   max-width:240px; //TODO:找到为什么要写死的原因
  //   > div {
  //     margin: 10px 0;
  //     background-color: #ffffff;
  //     padding: 10px;
  //     border-radius: 10px;
  //     color: #5e87e0;
  //   }
  //   > div:hover {
  //     cursor: pointer;
  //   }
  //   .more {
  //     text-decoration: underline;
  //     white-space: nowrap;
  //     overflow: hidden;
  //     text-overflow: ellipsis;
  //   }
  //   .more:hover {
  //     cursor: pointer;
  //     color: #1d6aff;
  //   }
  // }
}

/* 发送 */
.input_dom {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #f2f3f5;
  background-color: #fff;
  padding-bottom: calc(env(safe-area-inset-bottom, 0) + 8px);
  .input {
    flex: 1;
    height: 20px;
    background-color: #f1f1f1c5;
    outline: none;
    padding: 10px;
    border: none;
    border-radius: 10px;
  }
  .input:focus {
    outline: none;
  }
  .input::-webkit-input-placeholder {
    color: #c0c0c0;
  }
  .input:-moz-placeholder {
    color: #c0c0c0;
  }
  .input::-moz-placeholder {
    color: #c0c0c0;
  }
  .input:-ms-input-placeholder {
    color: #c0c0c0;
  }
}
.sendBtn {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

/* 弹出框 */
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 80%;
  background-color: #fff;
  border: 5px solid #6392fc;
  padding: 20px;
  border-radius: 5px;
  height: 300px;
  font-weight: 600;
  line-height: 20px;
  overflow-y: auto;
  font-size: 14px;
  height: 50%;
  overflow-y: scroll;
  p {
    color: rgba(0, 0, 0, 0.6);
  }
}

.linkText {
  color: #1d6aff;
  border-bottom: 1px dotted #1d6aff;
}
.linkText:hover {
  cursor: pointer;
}

/* 语音气泡 */
.voice-message {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;

  .voice-icon {
    width: 18px;
    height: 18px;
    object-fit: contain;
    flex-shrink: 0;
    transition: transform 0.2s;
    &.playing {
      animation: voice-pulse 0.8s ease-in-out infinite;
    }
  }

  .voice-text {
    font-size: 13px;
    white-space: nowrap;
  }
}

.voice-message--right {
  flex-direction: row-reverse;
  justify-content: flex-start;
  padding: 14px 20px;
  border-radius: 20px;
  background: #1d6aff;
  color: #ffffff;
  max-width: 70%;
}

@keyframes voice-pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
}

/* TTS 播报按钮 */
.tts-action {
  margin-top: 6px;
  display: flex;
  justify-content: flex-end;
}
.tts-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 50%;
  background: rgba(29, 106, 255, 0.12);
  color: #1d6aff;
  cursor: pointer;
  padding: 0;
  transition: background 0.2s, transform 0.1s;
  &:active {
    transform: scale(0.92);
  }
  &.tts-btn--playing {
    background: rgba(255, 77, 79, 0.15);
    color: #ff4d4f;
    animation: tts-pulse 1s ease-in-out infinite;
  }
}
@keyframes tts-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(255, 77, 79, 0.35); }
  50%       { box-shadow: 0 0 0 5px rgba(255, 77, 79, 0); }
}

/* 时间分割线 */
.time-divider {
  clear: both;
  display: flex;
  align-items: center;
  color: #999;
  font-size: 12px;
  margin: 10px 16px;
  gap: 8px;
  &::before,
  &::after {
    content: "";
    flex: 1;
  }
}

/* 输入中动画包装 */
.typing-wrapper {
  display: flex;
  margin: 10px;
  max-width: 90%;
  float: left;
  align-items: flex-start;
}

/* 输入行布局 */
.input_row {
  display: flex;
  align-items: center;
  padding: 10px 12px 18px 12px;
  gap: 8px;
  position: relative;
}

/* 模式切换按钮 */
.mic-btn {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f1f1f1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  transition: background 0.2s, transform 0.1s;
  &:active {
    background: #e0e0e0;
    transform: scale(0.95);
  }
  .mode-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
}

/* 语音输入按钮（按住说话）*/
.voice-input-btn {
  flex: 1;
  height: 40px;
  background: #f1f1f1;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  user-select: none;
  touch-action: none;
  transition: all 0.2s;
  &:active,
  &.voice-input-btn--active {
    background: #1d6aff;
    color: #fff;
    transform: scale(0.98);
  }
}

/* 录音全屏交互 */
.recording-fullscreen {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.92);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  user-select: none;
}

.recording-actions {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 90%;
  max-width: 400px;
  margin-bottom: 40px;
  margin-top: 40vh;
}

.action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  transition: transform 0.2s, opacity 0.2s;
  opacity: 0.4;
  &.active {
    opacity: 1;
    transform: scale(1.15);
  }
}

.action-cancel,
.action-text {
  flex: 0 0 auto;
  margin-top: 22px;
}

.action-center {
  flex: 1;
  max-width: 150px;
}

.action-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  .action-cancel.active & {
    background: #ff4d4f;
  }
  .action-text.active & {
    background: #1d6aff;
  }
}

.action-label {
  color: #fff;
  font-size: 14px;
  margin: 0;
  font-weight: 500;
}

.action-hint {
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  margin: 0;
}

.recording-guide {
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  margin: 0;
  text-align: center;
}

.recording-icon {
  display: flex;
  gap: 8px;
  align-items: flex-end;
  height: 48px;
  justify-content: center;
}

.rec-dot {
  display: inline-block;
  width: 8px;
  border-radius: 4px;
  background: #fff;
  animation: rec-wave 1s ease-in-out infinite;
  &:nth-child(1) {
    height: 20px;
    animation-delay: 0s;
  }
  &:nth-child(2) {
    height: 32px;
    animation-delay: 0.15s;
  }
  &:nth-child(3) {
    height: 20px;
    animation-delay: 0.3s;
  }
}

@keyframes rec-wave {
  0%,
  100% {
    transform: scaleY(0.6);
    opacity: 0.7;
  }
  50% {
    transform: scaleY(1);
    opacity: 1;
  }
}
</style>
